import React, { PureComponent } from 'react';
import './../assets/styles/login.scss'
import imgSISSAI from './../assets/images/SISSAI.png' 
import logo from './../assets/images/MagicChain.png';


interface Ilogin {
    children:React.ReactNode
}

class Login extends PureComponent<Ilogin> {

    constructor(props: Ilogin){
        super(props);
    }

    render(){ 
        return (
            <div className="main__login">
                <div>
                    <div className="content_image">
                        <img src={logo}/>
                    </div>
                    <div className="panel">
                        <div className="form">
                            {this.props.children}
                        </div>
                        <div className="image"> 
                            <div className="panel">
                                <div className="logo">
                                    <img src={imgSISSAI}/>
                                </div>
                                <div className="info">
                                    <label>Bienvenido al Sistema de Trazabilidad</label>
                                    <p>Inicie sesión de su cuenta</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Login;